import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ContractError, err, isError, ok } from "@nju/result";
import { IFetchStreetsResult, IParams, IStreet } from "./types";
import { serverResponse } from "./validators";

export async function fetchStreets({
  query,
  signal,
  cityId,
  postCode,
}: IParams): Promise<IFetchStreetsResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/installations/address/streets`,
    {
      signal,
      searchParams: {
        municipalityId: cityId,
        query,
        ...(postCode ? { postCode } : {}),
      },
    },
  );

  if (isError(result)) {
    if (result.err.code !== "REQUEST_ABORTED") {
      Bugsnag.notify(result.err);
    }
    return result;
  }

  const streets = Array.isArray(result.value)
    ? result.value.splice(0, 20)
    : result.value;

  const validated = serverResponse.safeParse(streets);

  if (!validated.success) {
    Bugsnag.notify(validated.error, (event) => {
      event.addMetadata("result", {
        response: result.value,
        municipalityId: cityId,
        postCode,
        query,
      });
    });
    return err(
      new ContractError({
        violations: validated.error,
        extra: {
          where: `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/installations/address/streets`,
        },
      }),
    );
  }

  const entries: IStreet[] = validated.data.map((street) => {
    return {
      id: street.streetId,
      name: street.street,
    };
  });

  return ok(entries);
}
